import script from "./BurtonDashboardPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./BurtonDashboardPicker.vue?vue&type=script&setup=true&lang=js"

import "./BurtonDashboardPicker.vue?vue&type=style&index=0&id=3f5c5a5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f5c5a5c"]])

export default __exports__